import { laptopMediumMax } from '@propertypal/shared/src/constants/mediaQueries';
import styled from 'styled-components';

export const HeroContainer = styled.div`
  background: linear-gradient(
    135deg,
    ${({ theme }) => theme.textDark} 0%,
    ${({ theme }) => theme.backgroundDark} 50%,
    ${({ theme }) => theme.backgroundLighter} 100%
  );
  position: relative;
  max-width: 100%;
  min-height: 160px;
  max-height: 500px;
  height: calc(100vh - 57px); // remove header height
  z-index: 1;

  @media (${laptopMediumMax}) {
    height: auto;
  }
`;

export const HeroImg = styled.div<{ img: string }>`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background: url(${({ img }) => img}) center center / cover no-repeat;
`;
